import { render } from "./UniversitasDetail.vue?vue&type=template&id=2453e95f"
import script from "./UniversitasDetail.vue?vue&type=script&lang=js"
export * from "./UniversitasDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__